// DesktopMenu.jsx
import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import SubMenu from './SubMenu';

const MenuItem = ({ item, isScrolled }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  const timeoutRef = useRef(null);
  
  const toggleSubmenu = () => setIsOpen(!isOpen);
  
  const handleMouseEnter = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    setIsOpen(true);
  };
  
  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setIsOpen(false);
    }, 100);
  };
  
  useEffect(() => {
    if (!item.submenu) return;
    
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [item.submenu]);
  
  if (item.submenu) {
    return (
      <div 
        ref={menuRef} 
        className="relative group"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <button 
          onClick={toggleSubmenu}
          className={`flex items-center px-4 py-2 text-sm font-medium transition-all duration-300 relative group text-white`}
          aria-expanded={isOpen}
          aria-haspopup="true"
        >
          <span>{item.label.toUpperCase()}</span>
          <svg 
            className={`ml-1 w-4 h-4 transition-transform duration-300 ${
              isOpen ? 'rotate-180' : ''
            }`} 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
          
          <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-salient-secondary transition-all duration-300 group-hover:w-full"></span>
        </button>
        
        {isOpen && (
          <div 
            className="absolute left-0 mt-2 w-56 origin-top-left rounded-md shadow-lg z-30 transform transition-all duration-300 opacity-100 scale-100"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <SubMenu items={item.submenu} />
          </div>
        )}
      </div>
    );
  }
  
  return (
    <Link 
      to={item.path}
      className={`px-4 py-2 text-sm font-medium transition-all duration-300 relative group text-white`}
    >
      <span>{item.label}</span>
      <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-salient-secondary transition-all duration-300 group-hover:w-full"></span>
    </Link>
  );
};

const DesktopMenu = ({ menuItems, isScrolled }) => {
  return (
    <div className="flex items-center space-x-1">
      {menuItems.map((item, index) => (
        <MenuItem key={index} item={item} isScrolled={isScrolled} />
      ))}
    </div>
  );
};

export default DesktopMenu;